// extracted by mini-css-extract-plugin
export default {"section":"Services_section__zezfP","card_wrapper":"Services_card_wrapper__guIDn","card":"Services_card__95IX3","images":"Services_images__Wv5sz"};